export default "__VITE_ASSET__BiiquzUq__"